import {
  Button,
  Popover,
  PopoverDisclosure,
  PopoverProvider,
  usePopoverStore,
  PopoverStore,
} from "@ariakit/react";
import { IconMoon } from "~/common/components/icons/moon";
import { IconChevronRight } from "~/common/components/icons/chevron-right";
import { userInfoStyle } from "~/auth/components/user-info.style";
import { IconCheck } from "~/common/components/icons/check";
import { useTheme } from "next-themes";
import { useState, useEffect } from "react";

type ThemeMenuProps = {
  parentPopoverStore?: PopoverStore;
};

export function ThemeMenu({ parentPopoverStore }: ThemeMenuProps) {
  const themePopover = usePopoverStore();
  const { theme, setTheme, systemTheme } = useTheme();
  const [activeTheme, setActiveTheme] = useState<string | undefined>();

  useEffect(() => {
    setActiveTheme(theme === "system" ? systemTheme : theme);
  }, [theme, systemTheme]);

  function handleSelectTheme(nextTheme: "dark" | "light") {
    setTheme(nextTheme);
  }

  const parentPopoverOpen = parentPopoverStore?.getState().open;

  useEffect(() => {
    if (!parentPopoverStore) return;
    const parentOpen = parentPopoverStore.getState().open;
    if (!parentOpen) {
      themePopover.setOpen(false);
    }
  }, [parentPopoverOpen, themePopover, parentPopoverStore]);

  const isActive = themePopover.useState("open");

  return (
    <PopoverProvider
      store={themePopover}
      placement="right-start"
    >
      <PopoverDisclosure
        className={userInfoStyle.popoverItemButton()}
        data-active={isActive || undefined}
      >
        <IconMoon color="currentColor" />
        <span className={userInfoStyle.popoverItemButtonText()}>Theme</span>
        <IconChevronRight color="currentColor" />
      </PopoverDisclosure>

      <Popover
        gutter={10}
        shift={-14}
        className={userInfoStyle.themePopoverContainer()}
      >
        <ul
          className="flex flex-col"
          onClick={(e) => e.stopPropagation()}
        >
          <li>
            <Button
              className={userInfoStyle.themePopoverItem()}
              onClick={() => handleSelectTheme("dark")}
            >
              <span className={userInfoStyle.checkIconWrapper()}>
                {activeTheme === "dark" ? <IconCheck /> : " "}
              </span>
              Dark
            </Button>
          </li>
          <li>
            <Button
              className={userInfoStyle.themePopoverItem()}
              onClick={() => handleSelectTheme("light")}
            >
              <span className={userInfoStyle.checkIconWrapper()}>
                {activeTheme === "light" ? <IconCheck /> : " "}
              </span>
              Light
            </Button>
          </li>
        </ul>
      </Popover>
    </PopoverProvider>
  );
}
